import React from "react";
import { withRouter } from "react-router";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import AssignmentReturnOutlined from "@material-ui/icons/AssignmentReturnOutlined";
import moment from "moment";
import { Api } from "../../utils/api";
import IconButton from "@material-ui/core/IconButton";
import SvgMore from "@material-ui/icons/ExpandMore";
import { Invoicexpress } from "../../utils/invoicexpress";
import { Tooltip } from "@material-ui/core";
import ConfirmDialog from "../../components/confirm.component";

class RequestsHistoryTableRow extends React.Component {
  state = {
    loading: true,
    invoices: [],
    receipts: [],
    expand: -1,
    showConfirm: false,
  };

  constructor() {
    super();
    this.goTo = this.goTo.bind(this);
    this.handleExpand = this.handleExpand.bind(this);
    this.api = new Api();
    this.iexpress = new Invoicexpress();
  }

  goTo(location, params) {
    this.props.history.push(location, params);
  }

  getInvoiceData(invoiceId) {
    return this.props.invoices.find((invoice) => {
      return invoice && invoice.invoice ? invoice.invoice.id === invoiceId : {};
    });
  }

  getInvoiceCreditNote(invoiceId) {
    let invoice = this.props.invoices.find((invoice) => {
      return invoice && invoice.invoice ? invoice.invoice.id === invoiceId : -1;
    });

    if (!invoice) return;
    if (!invoice.related_documents) return;

    return invoice.related_documents.invoices.find((doc) => {
      return doc.type === "CreditNote" && doc.status === "settled";
    });
  }

  getReversalReceipt(payment) {
    return this.api
      .get("easypay_payment_invoices", {
        easypay_payment_id: payment.ep_key,
        reversal: true,
      })
      .then(({ data = null }) => {
        if (data.count > 0) {
          let invoice_id =
            data.easypay_payment_invoices[0].invoicexpress_invoice_id;
          let invoice_type =
            data.easypay_payment_invoices[0].invoice_type === "reversal-invoice"
              ? "invoice"
              : "receipt";
          return this.iexpress.getInvoiceData(invoice_id, invoice_type);
        }
      });
  }

  getReceipt(payment) {
    if (this.getInvoiceCreditNote(payment.invoice_id)) {
      return this.props.receipts.find((receipt) => {
        return receipt.easypay_payment_id === payment.ep_key;
      });
    }
  }

  getInvoiceTextColor(invoiceStatus) {
    switch (invoiceStatus) {
      case "final":
        return "blue";
      case "settled":
        return "green";
      case "canceled":
        return "red";
      case "deleted":
        return "#212529";
      case "draft":
      default:
        return "orange";
    }
  }

  getInvoiceText(invoice, adminMode) {
    if (!invoice) return;

    switch (invoice.status) {
      case "draft":
        return adminMode ? "Rascunho" : "A aguardar";
      case "deleted":
        return "Apagado";
      default:
        switch (invoice.type) {
          case "Invoice":
            return "FT " + invoice.sequence_number;
          case "InvoiceReceipt":
            return "FR " + invoice.sequence_number;
          case "CreditNote":
            return "NC " + invoice.sequence_number;
          case "Receipt":
            return "R " + invoice.sequence_number;
          default:
            return invoice.sequence_number;
        }
    }
  }

  canCreateCreditNote(invoiceId) {
    let creditNote = this.getInvoiceCreditNote(invoiceId);
    let invoiceData = this.getInvoiceData(invoiceId);
    return (
      !creditNote &&
      invoiceData &&
      invoiceData.invoice &&
      (invoiceData.invoice.status === "final" ||
        invoiceData.invoice.status === "settled")
    );
  }

  doInvoiceClickAction(invoiceId, ep_key, adminView) {
    if (adminView) {
      if (this.getInvoiceData(invoiceId).invoice.status === "draft") {
        this.setState({
          showConfirm: true,
          payment_id: ep_key,
          invoiceId: invoiceId,
        });
      } else this.iexpress.openInvoice(invoiceId);
    } else {
      this.iexpress.openInvoicePdf(invoiceId);
    }
  }

  handleExpand(invoiceId) {
    if (this.state.expand === -1) {
      this.setState({
        expand: invoiceId,
      });
      document.getElementById("datatable-column-invoicedate").scrollIntoView();
    } else
      this.setState({
        expand: -1,
      });
  }

  /**
   *
   */
  componentDidMount() {}

  render() {
    var { payment, showAllColumns } = this.props;
    let invoiceData = this.getInvoiceData(payment.invoice_id);
    let invoiceColor, creditNoteData, creditNodeColor, creditNodeText;

    if (invoiceData && invoiceData.invoice) {
      invoiceColor = this.getInvoiceTextColor(invoiceData.invoice.status);
      creditNoteData = this.getInvoiceCreditNote(payment.invoice_id);
    }

    if (creditNoteData) {
      creditNodeText = this.getInvoiceText(creditNoteData, showAllColumns);
      creditNodeColor = this.getInvoiceTextColor(creditNoteData.status);
    }

    return (
      <>
        <TableRow
          key={payment.ep_key}
          style={
            this.props.idx % 2
              ? { background: "lightgray" }
              : { background: "white" }
          }
        >
          <TableCell align="left">
            {invoiceData &&
            invoiceData.related_documents &&
            invoiceData.related_documents.invoices.length > 0 ? (
              <IconButton
                color="primary"
                onClick={() => this.handleExpand(payment.invoice_id)}
              >
                <SvgMore />
              </IconButton>
            ) : null}
          </TableCell>
          <TableCell
            align="left"
            style={{
              position: "sticky",
              left: 0,
              zIndex: 0,
              background: this.props.idx % 2 ? "lightgray" : "white",
            }}
          >
            {payment.invoice_id && invoiceData && (
              <>
                <div
                  style={{
                    width: "max-content",
                    borderStyle: "solid",
                    borderWidth: "medium",
                    textAlign: "center",
                    borderColor: invoiceColor,
                  }}
                >
                  <Tooltip title="Ver documento">
                    <a
                      style={{ color: invoiceColor }}
                      onClick={() => {
                        this.doInvoiceClickAction(
                          payment.invoice_id,
                          payment.ep_key,
                          showAllColumns
                        );
                      }}
                    >
                      {this.getInvoiceText(invoiceData.invoice, showAllColumns)}
                    </a>
                  </Tooltip>
                </div>
              </>
            )}
          </TableCell>
          <TableCell style={{ minWidth: "150px" }}>
            {payment.invoice_id &&
              invoiceData &&
              (invoiceData.invoice
                ? moment(invoiceData.invoice.date).format("YYYY-MM-DD")
                : "")}
          </TableCell>
          <TableCell align="left" style={{ minWidth: "150px" }}>
            {payment.invoice_id &&
              invoiceData &&
              (invoiceData.invoice ? invoiceData.invoice.total + "€" : "")}
          </TableCell>
          <TableCell align="left" style={{ minWidth: "150px" }}>
            {payment.payment_at
              ? moment(payment.payment_at).format("YYYY-MM-DD")
              : "N/A"}
          </TableCell>
          <TableCell align="left">{payment.payment_method}</TableCell>
          <TableCell align="left" style={{ minWidth: "150px" }}>
            {payment.ep_status}
          </TableCell>
          <TableCell align="left" style={{ minWidth: "150px" }}>
            {payment.ep_status === "Pago"
              ? moment(payment.ep_date).format("YYYY-MM-DD")
              : "N/A"}
          </TableCell>
          <TableCell align="left" style={{ minWidth: "200px" }}>
            {invoiceData &&
              invoiceData.invoice &&
              invoiceData.invoice.client.id && (
                <>
                  <a
                    onClick={() =>
                      new Invoicexpress().openClient(
                        invoiceData.invoice.client.id
                      )
                    }
                  >
                    {payment.entity_name}
                  </a>
                </>
              )}
            {!invoiceData && <>{payment.entity_name}</>}
          </TableCell>
          <TableCell align="left" style={{ minWidth: "200px" }}>
            {payment.establishment}
          </TableCell>
          <TableCell align="left" style={{ minWidth: "200px" }}>
            {payment.district}
          </TableCell>
          <TableCell align="left" style={{ minWidth: "200px" }}>
            {payment.county}
          </TableCell>
          <TableCell align="left" style={{ minWidth: "200px" }}>
            {payment.user_name ? payment.user_name : "N/A"}
          </TableCell>
          <TableCell align="left" style={{ minWidth: "200px" }}>
            {payment.elderly_name ? payment.elderly_name : "N/A"}
          </TableCell>
          <TableCell align="left" style={{ minWidth: "150px" }}>
            {payment.request_admitted}
          </TableCell>
          <TableCell align="left">
            {payment.monthly_payment != null
              ? payment.monthly_payment + "€"
              : ""}
          </TableCell>
          <TableCell align="left">
            {payment.jewelry_value != null ? payment.jewelry_value : "-"}
          </TableCell>
          <TableCell
            align="left"
            style={{ minWidth: "200px" }}
            hidden={!showAllColumns}
          >
            {payment.social_worker_name ? payment.social_worker_name : "N/A"}
          </TableCell>
          <TableCell
            align="left"
            style={{ minWidth: "200px" }}
            hidden={!showAllColumns}
          >
            {payment.admin_name ? payment.admin_name : "N/A"}
          </TableCell>
          <TableCell align="left" hidden={!showAllColumns}>
            {}
          </TableCell>
          <TableCell
            align="left"
            style={{ minWidth: "150px" }}
            hidden={!showAllColumns}
          >
            {payment.request_accepted != null
              ? moment(payment.request_accepted).format("YYYY-MM-DD")
              : ""}
          </TableCell>
          <TableCell
            align="left"
            style={{ minWidth: "150px" }}
            hidden={!showAllColumns}
          >
            {payment.request_confirmed != null
              ? moment(payment.request_confirmed).format("YYYY-MM-DD")
              : ""}
          </TableCell>
          <TableCell align="left" hidden={!showAllColumns}>
            {creditNoteData ? "Accionada" : "-"}
          </TableCell>
          <TableCell align="left" hidden={!showAllColumns}>
            {creditNoteData && creditNoteData.sequence_number && (
              <>
                <div
                  style={{
                    width: "max-content",
                    borderStyle: "solid",
                    borderWidth: "medium",
                    textAlign: "center",
                    borderColor: invoiceColor,
                  }}
                >
                  <Tooltip title="Ver documento">
                    <a
                      onClick={() =>
                        this.iexpress.openInvoice(
                          creditNoteData.id,
                          "creditnote"
                        )
                      }
                      style={{ color: creditNodeColor }}
                    >
                      {creditNodeText}
                    </a>
                  </Tooltip>
                </div>
              </>
            )}
            {this.canCreateCreditNote(payment.invoice_id) && (
              <Tooltip title="Criar NC">
                <Button
                  color="primary"
                  onClick={() =>
                    this.goTo("/credit_notes", { invoice: payment.invoice_id })
                  }
                >
                  <AssignmentReturnOutlined />
                </Button>
              </Tooltip>
            )}
          </TableCell>
          <TableCell
            align="left"
            style={{ minWidth: "150px" }}
            hidden={!showAllColumns}
          >
            {this.getInvoiceCreditNote(payment.invoice_id) &&
              this.getInvoiceCreditNote(payment.invoice_id).date}
          </TableCell>
          <TableCell align="left" hidden={!showAllColumns}>
            {this.getReceipt(payment) && (
              <>
                <div
                  style={{
                    width: "max-content",
                    borderStyle: "solid",
                    borderWidth: "medium",
                    textAlign: "center",
                    borderColor: this.getInvoiceTextColor(
                      this.getReceipt(payment).invoice.status
                    ),
                  }}
                >
                  <Tooltip title="Ver documento">
                    <a
                      onClick={() =>
                        this.iexpress.openInvoice(
                          this.getReceipt(payment).invoice.id
                        )
                      }
                      style={{
                        color: this.getInvoiceTextColor(
                          this.getReceipt(payment).invoice.status
                        ),
                      }}
                    >
                      {this.getInvoiceText(
                        this.getReceipt(payment).invoice,
                        showAllColumns
                      )}
                    </a>
                  </Tooltip>
                </div>
              </>
            )}
          </TableCell>
          <TableCell
            align="left"
            style={{ minWidth: "200px" }}
            hidden={!showAllColumns}
          >
            {this.getReceipt(payment) && this.getReceipt(payment).invoice.date}
          </TableCell>
          <TableCell align="left" hidden={!showAllColumns}>
            {this.getReceipt(payment) && this.getReceipt(payment).invoice.total}
          </TableCell>
        </TableRow>
        {this.state.expand === payment.invoice_id &&
          invoiceData.related_documents.invoices.length > 0 && (
            <TableRow className="entity-invoices-row-grouped">
              <TableCell colSpan="4" style={{ paddingLeft: 0 }}>
                <Table>
                  <TableBody>
                    {invoiceData.related_documents.invoices.map((doc) => (
                      <TableRow key={doc.id}>
                        <TableCell></TableCell>
                        <TableCell
                          align="left"
                          className="entity-invoices-row-grouped"
                          style={{
                            position: "sticky",
                            left: 0,
                            zIndex: 1,
                            width: "120px",
                          }}
                        >
                          <>
                            <div
                              style={{
                                width: "max-content",
                                borderStyle: "solid",
                                borderWidth: "medium",
                                textAlign: "center",
                                borderColor: this.getInvoiceTextColor(
                                  doc.status
                                ),
                                color: this.getInvoiceTextColor(doc.status),
                              }}
                            >
                              <Tooltip title="Ver documento">
                                <a
                                  onClick={() => {
                                    this.iexpress.openInvoice(doc.id, doc.type);
                                  }}
                                >
                                  {this.getInvoiceText(doc, showAllColumns)}
                                </a>
                              </Tooltip>
                            </div>
                          </>
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{ paddingLeft: "0px", width: "140px" }}
                        >
                          {doc.date}
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{ paddingLeft: "0px", width: "120px" }}
                        >
                          {doc.total}€
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableCell>
            </TableRow>
          )}

        <ConfirmDialog
          open={this.state.showConfirm}
          title={"Atenção"}
          message={
            "Pretende ver a fatura no Invoicexpress ou pretende clonar esta fatura?"
          }
          handleOk={() => {
            this.goTo(`/invoices/${this.state.payment_id}`);
          }}
          handleCancel={() => {
            this.iexpress.openInvoice(this.state.invoiceId);
            this.setState({ showConfirm: false });
          }}
          buttons={["Ver fatura", "Clonar fatura"]}
        ></ConfirmDialog>
      </>
    );
  }
}

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
  paper: {
    width: "100%",
    height: "400px",
    overflow: "scroll",
  },
  head: {
    backgroundColor: "#104363",
    color: "white",
    position: "sticky",
    top: 0,
    align: "left",
  },
});

export default withRouter(RequestsHistoryTableRow);
